import { types } from "../types/types";

const defaultState = {
  modalOpen: false,
  cityCode: 1,
  coverageCode: 0,
  userLocation: { lat: 0, lng: 0 },
  loaddingPage: false,
  //Drivers Maps
  showOrdersDriver: false,
  showDriverFree: false,
  showDriverBusy: false,
  //Orders Maps
  showOrdersInProccess: false,
  showOrdersReady: false,
  showOrdersDispatched: false,
  showGroup: false,

  showOrdersAssigned: false,
  showOrdersDispatchedMarker: false,
  showOrdersUnassigned: false,
  showVehicleType: 0,

  tabPanelLeftActive: false,
  tabPanelRightActive: false,

  tipSelected: 0,

  acceptsOrdersActive: false,

  showAverageOrders: false,
};

const initialState = (() => {
  const config = localStorage.getItem("configUser");
  if (config) return JSON.parse(config);
  return defaultState;
})();

export const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.uiOpenModal:
      return {
        ...state,
        modalOpen: true,
      };
    case types.setCity:
      return {
        ...state,
        cityCode: action.payload,
      };
    case types.setCoverage:
      return {
        ...state,
        coverageCode: action.payload,
      };
    case types.uiSetTipSelected:
      return {
        ...state,
        tipSelected: action.payload
      };
    case types.loaddingPageShow:
      return {
        ...state,
        loaddingPage: true,
      };
    case types.loaddingPageNone:
      return {
        ...state,
        loaddingPage: false,
      };
    case types.showOrdersDriver:
      return {
        ...state,
        showOrdersDriver: action.payload,
      };
    case types.showDriverFree:
      return {
        ...state,
        showDriverFree: action.payload,
      };
    case types.showDriverBusy:
      return {
        ...state,
        showDriverBusy: action.payload,
      };
    case types.showOrdersInProccess:
      return {
        ...state,
        showOrdersInProccess: action.payload,
      };
    case types.showOrdersReady:
      return {
        ...state,
        showOrdersReady: action.payload,
      };
    case types.showOrdersDispatched:
      return {
        ...state,
        showOrdersDispatched: action.payload,
      };
    case types.showOrdersAssigned:
      return {
        ...state,
        showOrdersAssigned: action.payload,
      };
    case types.showOrdersDispatchedMarker:
      return {
        ...state,
        showOrdersDispatchedMarker: action.payload,
      };
    case types.showOrdersUnassigned:
      return {
        ...state,
        showOrdersUnassigned: action.payload,
      };
    case types.showGroup:
      return {
        ...state,
        showGroup: !state.showGroup,
      };
    case types.offAllSwitchTop:
      return {
        ...state,
        showOrdersInProccess: false,
        showOrdersReady: false,
        showOrdersDispatched: false,
      };
    case types.offAllSwitchButtom:
      return {
        ...state,
        showOrdersAssigned: false,
        showOrdersDispatchedMarker: false,
        showOrdersUnassigned: false,
      };
    case types.showVehicleType:
      return {
        ...state,
        showVehicleType: action.payload,
      };
    case types.tapPanelLeftActive:
      return {
        ...state,
        tabPanelLeftActive: action.payload,
      };
    case types.tapPanelRightActive:
      return {
        ...state,
        tabPanelRightActive: action.payload,
      };
    case types.acceptsOrdersActive:
      return {
        ...state,
        acceptsOrdersActive: action.payload,
      };
    case types.isShowAverageOrders:
      return {
        ...state,
        showAverageOrders: !state.showAverageOrders,
      };
    default:
      return state;
  }
};
